// Utility functions for widget permissions
import { isWidgetAllowedForContext, isTabAllowedForContext } from './permissionContext';

// Map API widget names to internal widget identifiers
export const WIDGET_MAPPING = {
  Impressions: 'impressions',
  clicks: 'clicks',
  media_cost: 'mediaCost',
  installs: 'installs',
  kpi_events: 'kpiEvent',
  mmp_installs: 'mmpInstalls',
  mmp_events: 'mmpEvents',
  skan_installs: 'skanInstalls'
};

// Check if a widget should be visible based on user permissions and current context
export const isWidgetAllowed = (widgetName, userPermissions, currentTimezone = 'UTC', currentDataType = 'nonskan') => {
  return isWidgetAllowedForContext(widgetName, userPermissions, currentTimezone, currentDataType);
};

// Get filtered widgets based on user permissions and current context
export const getFilteredWidgets = (allWidgets, userPermissions, currentTimezone = 'UTC', currentDataType = 'nonskan') => {
  return allWidgets.filter((widget) => isWidgetAllowed(widget.name, userPermissions, currentTimezone, currentDataType));
};

// Check if a tab/page should be visible based on user permissions and current context
export const isTabAllowed = (tabName, userPermissions, currentTimezone = 'UTC', currentDataType = 'nonskan') => {
  return isTabAllowedForContext(tabName, userPermissions, currentTimezone, currentDataType);
};
